export default {
  props: {
    teacherData: {
      required: true,
      defalut: {},
      type: Object
    }
  },

  created() {// console.log(this.teacherData);
  },

  data() {
    return {
      pageTitle: this.$utils.getUrlParams('name'),
      menuId: this.$utils.getUrlParams('menuId')
    };
  },

  methods: {
    openDetail() {
      window.location.href = `/teacherDetailInfo.html?id=${this.teacherData.id}&name=${this.pageTitle}&menuId=${this.menuId}`; // window.open(
      //   `${this.$schoolUrl}/teacherDetailInfo.html?id=${this.teacherData.teacher_id || this.teacherData.id}`
      // );
    }

  }
};